module.exports = __webpack_public_path__ + "static/media/maria_rachel.ffc79973.jpg";